<template>
  <div class="detail">
    <div class="detail-header" style="position: flex;">
      <img @click="closePage" src="@/assets/imageIntegral/close-black.png" alt="">
      <div>等级明细</div>
      <div></div>
    </div>
    <div v-if="dataList === 0">
    </div>
    <div class="detail-list" v-else-if="dataList.length">
      <ul>
          <!-- :load-more-txt="'没有更多数据了'" -->
        <nut-infiniteloading
          :load-icon="'loading'"
          :load-txt="''"
          :load-more-txt="'没有更多数据了'"
          :has-more="hasMore"
          @load-more="customLoadMore"
        >
          <li
            v-for="(item, index) in dataList"
            :key="'integral-list' + index"
          >
            <div class="list-row">
              <div class="row-border">
                <div>
                  <p class="descTitle">{{item.desc}}</p>
                  <p class="font_size14" v-if="item.pid" style="opacity:0.7;font-weight:bold;">ID<span style="width: 2px;display:inline-block;"></span>{{item.pid}}</p>
                  <p class="row_time font_size14">{{item.time}}</p>
                </div>
                <div>{{String(item.amount).includes('-') ? item.amount : '+' + item.amount}}</div>
              </div>
            </div>
          </li>
        </nut-infiniteloading>
      </ul>
    </div>
    <div class="data-none" v-else>
      <img :src="dataNoneImg" alt="" srcset="">
      暂无经验记录
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, onMounted, getCurrentInstance } from 'vue';

import request from '@/utils/request.js';
import * as api from '@/utils/apiIntegral.js';
import { useStore } from 'vuex'
// import VConsole from 'vconsole';

import dataNoneImg from '@/assets/imageIntegral/无经验值记录.png'

export default defineComponent({
  setup() {
    const store = useStore()
    // const vconsole = new VConsole()
    // console.log(vconsole);
    const { beacon } = getCurrentInstance().appContext.config.globalProperties;
    const data = reactive({
      hasMore: true,
      dataList: 0,
      pageNumber: 1,
      dataNoneImg,
      count:0,// 总条数
      // ulHeight: 'auto'
    });
    onMounted(() => {
      init();
      beacon.onUserAction('level_detail_show')
    });
    const closePage = () => {
      window.history.back();
    };
    const init = () => {
      let obj = {
        "common": {
          "vcode":"31000008",
          "version":"3.10.0",
          // "vcode": "31000008",
          // "version": "110211"
        },
        "pageSize": 10,
        "pageNumber":data.pageNumber,
      }
      let openId = store.getters.userInfo ? 
        store.getters.userInfo.split('/')[0] : null;
      // 是否传openId
      store.getters.haveOpenId ? obj['common']['openid'] = openId : ''
      request('post', api.userLevelRelatedDetailList, obj).then(res => {
        console.log('等级明细', res)
        if (res.data) {
          // console.log(data.dataList);
          data.count = res.data.count
          // data.dataList = [...res.data.list]
          if(data.dataList === 0){
            data.dataList = [...res.data.list]
            // data.dataList = [...res.data.list.splice(1)]
            // data.ulHeight = data.dataList.length * 154 + 'px'
          }else{
            data.dataList = [...data.dataList,...res.data.list]
          }
          if(data.dataList.length >= data.count){
            data.hasMore = false;
          }
          if(data.dataList.length <= 10 && data.count <= 10){
            data.hasMore = true
          }

        }
      });
    };
    const customLoadMore = (
      done
    ) => {
      console.log(data.pageNumber,'number');
      data.pageNumber++;
      init();
      if(data.dataList.length >= data.count){
        // data.ulHeight = 'auto'
        data.hasMore = false;
      }
      done();
    };
    return {
      ...toRefs(data),
      closePage,
      init,
      // hasMore,
      customLoadMore,
    };
  },
})
</script>

<style lang="scss" scoped>
.detail {
  background-color: #F4F4FB;
  height: 100vh;
  .detail-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 555;
    width: 100%;
    height: 52px;
    display: flex;
    padding: 13px 20px 13px 20px;
    justify-content: space-between;
    align-items: center;
    color: #000;
    background-color: #fff;
    img {
      width: 20px;
    }
    div:first-of-type {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .detail-list {
    margin-top: 62px;
    background-color: #fff;
    // ul{
    //   padding-bottom: 20px;
    // }
    .list-row {
      padding: 16px 20px 0 20px;
      .row-border {
        border-bottom: 1px solid rgba(0,0,0,0.1);
        padding-bottom: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        div {
          color: #FF8400;
          font-weight: bold;
          font-size: 16px;
          p {
            color: #000000;
            font-weight: 400;
            line-height: 30px;
          }
        }
        .descTitle{
          font-weight: bold;
          opacity: 0.9;
        }
        .row_time{
          opacity: 0.5;
          font-weight: bold;
        }
        .font_size14{
          font-size: 14px;
        }
      }
    }
    >>> .nut-infinite-bottom{
      padding: 0;
    }
  }
  .data-none {
    height: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 16px;
    color: #000000;
    font-weight: bold;
    img {
      width: 132px;
      margin-bottom: 16px;
    }
  }
}
</style>